import PropTypes from 'prop-types'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import {
  StyledContainer,
  StyledHeader,
  StyledTitle,
  StyledTopContainer,
} from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/CommunicationBoard/styled-components'
import CommunicationBoardEmptyState from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/CommunicationBoard/CommunicationBoardEmptyState'
import CommunicationBoardList from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/CommunicationBoard/CommunicationBoardList'

const CommunicationBoardContent = ({ t, visibleSections, sections, error }) => {
  return (
    <StyledContainer>
      <StyledTopContainer>
        <StyledHeader>
          <StyledTitle>{t('subscriptionForm:communication_board.title')}</StyledTitle>
        </StyledHeader>
      </StyledTopContainer>

      <SDNotification type='negative' hidden={!error} primaryText={error} />
      <CommunicationBoardEmptyState t={t} hidden={visibleSections.length > 0 || !!error} />
      <CommunicationBoardList
        t={t}
        hidden={visibleSections.length === 0 || !!error}
        visibleSections={visibleSections}
        sections={sections}
      />
    </StyledContainer>
  )
}

CommunicationBoardContent.propTypes = {
  t: PropTypes.func.isRequired,
  visibleSections: PropTypes.array.isRequired,
  sections: PropTypes.array.isRequired,
  error: PropTypes.string,
}

export default CommunicationBoardContent
